module.exports = __webpack_public_path__ + "static/media/snoopysnow02.cb225f92.gif";